import PropTypes from "prop-types";
import { FlexContainers, WrapperContainer } from "../../../../../components";
import FeaturesListRow from "./FeaturesListColumn";

const FeaturesSectionList = ({ features }) => {
  const featuresLength = features?.length ?? 0;
  let current = 0;

  const FeaturesLists = [];

  while (current <= featuresLength) {
    FeaturesLists.push(
      <FeaturesListRow key={current} features={features.slice(current, current + 3)} />
    );
    current += 3;
  }

  return (
    <WrapperContainer Container={FlexContainers.FlexColumnStart} gap={16} pl={5} alignItems="start">
      {FeaturesLists}
    </WrapperContainer>
  );
};

FeaturesSectionList.propTypes = {
  features: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string,
      settingName: PropTypes.string,
      name: PropTypes.string,
      value: PropTypes.bool.isRequired
    })
  ).isRequired
};

export default FeaturesSectionList;
